import { ColSpanParams, RowNode } from 'ag-grid-community';
import { Column } from 'components/atoms/grid';
import { moveInPlace } from 'utils/arrays';
import { editableWhen } from '../editable-when';

export const postSort = (rowNodes: RowNode[]) => {
  const addRowIndex = rowNodes.findIndex((x) => x.id === 'provisional');

  if (addRowIndex > -1) {
    moveInPlace(rowNodes.length - 1, addRowIndex, rowNodes);
  }
};

const disallowEditingOnProvisionalRow = editableWhen(
  ({ node }) => node.id !== 'provisional',
);

const colSpan =
  (count: number) =>
  ({ node: { id } }: ColSpanParams) =>
    id === 'provisional' ? count - 1 : 1;

const withColSpan = (column: Column, i: number, all: Column[]): Column =>
  i === 0 ? { ...column, colSpan: colSpan(all.length) } : column;

export const getColumns = (columns: Column[]) =>
  columns.map(disallowEditingOnProvisionalRow).map(withColSpan);
